const Hero = () => {
  return (
    <div className='p-6'>
      <img
        src='https://demo.templatetrend.com/magento/Euforia/images/header.jpg'
        alt=''
      />
    </div>
  );
};

export default Hero;
